import SplitScreen from './split-screen';

export default SplitScreen;
